import React from 'react';
import { Main } from './components';

const Packaging: React.FC = () => {
  return <Main />;
};

export default Packaging;
